export default __webpack_public_path__ + "locales/sk/DeleteProfileEverDialog.json?hash=1d2b8037b68cca2301b260e808f36e82";